import { assetsCommandServerUrl } from '@modul-connect/shared/config'
import { useEffect, useState } from 'react'
import { postAsync } from '../../../../../utils/ajax'
import { getStore } from '../../../../../state/configureStore'
import View from '@modul-connect/shared/components/atoms/view'
import BluetoothIcon from '@modul-connect/shared/img/BluetoothIcon.svg'
import { InfoText } from '@modul-connect/shared/components/atoms/text/text'
import { getFrequencyOptions, InputSection } from './addMaintenanceModal'
import { Dropdown } from '@modul-connect/shared/components/molecules/dropdown/dropdown'
import { DateSelector } from '@modul-connect/shared/components/molecules/daySelector/daySelector'
import Button from '@modul-connect/shared/components/atoms/button/button.v2'
import { DateTime } from 'luxon'
import { VehicleIcon } from './addNewAssetWithMaintenance'

const AddMaintenanceToExistingAsset = ({
  onSave,
  onClose,
  vehiclesWithAssets,
  tokenState
}) => {
  const NewBluetoothIcon = <img src={BluetoothIcon} />
  const [selectedAsset, setSelectedAsset] = useState()
  const [selectedVehicle, setSelectedVehicle] = useState()
  const [frequency, setFrequency] = useState('')
  const [date, setDate] = useState(DateTime.local())

  useEffect(() => {
    if (frequency || frequency === 0)
      setDate(DateTime.local().plus({ days: frequency }))
  }, [frequency])

  const getOptionsFromVehicles = (vehicles, onSelectVehicle) => {
    if(vehicles.length === 0) return []
    const options = vehicles.map(vehicle => {
      return {
        id: vehicle.vin,
        name: vehicle.vehicleName,
        onSelect: onSelectVehicle,
        icon: VehicleIcon,
        value: vehicle
      }
    })
    return options
  }

  const getOptionsFromAssets = (assets, onSelectAsset) => {
    const options = assets.map(asset => {
      return {
        name: asset.name,
        onSelect: onSelectAsset,
        value: asset.assetId
      }
    })
    return options
  }

  const postMaintenanceToExistingAsset = async (accessToken, assetId, frequency, dueDate) => {
    const url = assetsCommandServerUrl() + '/cmd/add-maintenance-to-existing-asset'
    const body = {
      assetId: assetId,
      frequency: frequency,
      dueDate: dueDate
    }
    const result = await postAsync(accessToken, url, body)
    if (result?.status == 'ok') {
      getStore().dispatch({ type: 'SHOW_SUCCESS_NOTIFICATION', message: 'Maintenance assigned to asset' })
    }
    else {
      getStore().dispatch({ type: 'SHOW_WARNING_NOTIFICATION', message: 'Failed to assign maintenance to asset' })
    }
  }


  return (
    <>
      <View style={{ display: 'flex', flexDirection: 'row', gap: 8, marginBottom: 16, width: '100%', alignItems: 'center' }}>
        <View style={{ alignSelf: 'flex-start' }}>
          {NewBluetoothIcon}
        </View>

        <InfoText>
          Important! <br />
          This option is intended for trackable equipment only.
        </InfoText>
      </View>
      <InputSection>
        <Dropdown
          options={getOptionsFromVehicles(vehiclesWithAssets, setSelectedVehicle)}
          placeholder={'Select vehicle'}
          value={selectedVehicle}
          onChange={(e) => {
            setSelectedVehicle(e),
            setSelectedAsset(undefined)
          }}
          isRequired />

        <Dropdown
          options={getOptionsFromAssets(selectedVehicle ? selectedVehicle.assets : [], setSelectedAsset)}
          placeholder={'Select asset tracker'}
          value={selectedAsset}
          onChange={setSelectedAsset}
          isRequired
          disabled={!selectedVehicle}/>

        <Dropdown
          title={'Maintenance frequency'}
          options={getFrequencyOptions([])}
          placeholder={'Select frequency'}
          value={frequency}
          onChange={setFrequency}
          isRequired />

        <DateSelector
          title={'Due date'}
          date={date}
          onDayPicked={(newDate) => setDate(newDate)}
          disableDaysBefore={DateTime.local()}
          isRequired
        />

        <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', fontSize: 12 }}>
          * Required fields
        </View>

        <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', gap: 10 }}>
          <Button
            extend={{ width: '30%' }}
            onClick={() => {
              postMaintenanceToExistingAsset(tokenState, selectedAsset, frequency, date)
              onSave()
            }}
            disabled={frequency === undefined || !date || !selectedAsset}
          >
            {'Save'}
          </Button>

          <Button
            noBg
            border
            onClick={() => {
              onClose()
            }}
          >
            {'Cancel'}
          </Button>
        </View>
      </InputSection>
    </>
  )
}

export default AddMaintenanceToExistingAsset